module.exports = __webpack_public_path__ + "bb3b53136b400aeed6d4d070d2869c37.svg";